module.exports = __webpack_public_path__ + "img/_2_schrauben_montage.4c01c287.svg";